<template>
  <v-dialog
    :value="showClassTimeDialog"
    @input="closeDialog()"
    @keydown.esc="closeDialog()"
    max-width="1000"
  >
    <v-card tile>
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Cadastro de Horário</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="save">
            <v-icon>mdi-check</v-icon>
            <div class="d-none d-sm-flex">Salvar</div>
          </v-btn>
          <v-btn dark text @click="closeDialog">
            <v-icon>mdi-close</v-icon>
            <div class="d-none d-sm-flex">Cancelar</div>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-subheader>Horários da aula na semana</v-subheader>
        <v-form v-model="valid">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="3">
                <div>Horário de início</div>
                <vue-timepicker
                  @change="change"
                  hide-clear-button
                  auto-scroll
                  close-on-complete
                  v-model="classSchedule.timeStart"
                ></vue-timepicker>
              </v-col>
            </v-row>
            <v-row align="start" justify="start">
              <v-col cols="12" md="4">
                <v-text-field
                  :counter="50"
                  label="Nome do professor"
                  v-model="classSchedule.coachName"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :counter="50"
                  label="Local da aula"
                  v-model="classSchedule.classRoom"
                />
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row class="d-flex" align="center">
              <v-chip-group
                v-model="classSchedule.dayOfWeek"
                column
                :multiple="classSchedule.editMode"
                mandatory
              >
                <v-chip filter active-class="primary--text font-weight-black">Domingo</v-chip>
                <v-chip filter active-class="primary--text font-weight-black">Segunda</v-chip>
                <v-chip filter active-class="primary--text font-weight-black">Terça</v-chip>
                <v-chip filter active-class="primary--text font-weight-black">Quarta</v-chip>
                <v-chip filter active-class="primary--text font-weight-black">Quinta</v-chip>
                <v-chip filter active-class="primary--text font-weight-black">Sexta</v-chip>
                <v-chip filter active-class="primary--text font-weight-black">Sábado</v-chip>
              </v-chip-group>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    VueTimepicker
  },
  data: () => ({
    valid: null
  }),
  methods: {
    ...mapActions("showClass", [
      "ActionSetShowClassTimeDialog",
      "ActionSetArrayClassSchedules"
    ]),
    save() {
      this.classSchedule.editMode ? this.saveEditMode() : this.closeDialog();
    },
    saveEditMode() {
      let arrayTimes = [];
      let weekDays = this.classSchedule.dayOfWeek;

      for (let i of weekDays) {
        let newTime = {
          id: this.classSchedule.id,
          classId: this.classSchedule.classId,
          dayOfWeek: 0,
          classRoom: this.classSchedule.classRoom,
          coachName: this.classSchedule.coachName,
          timeStart: this.classSchedule.timeStart
        };
        newTime.dayOfWeek = i;
        arrayTimes.push(newTime);
      }
      this.ActionSetArrayClassSchedules(arrayTimes);
      this.change();
      this.closeDialog();
    },
    closeDialog() {
      this.ActionSetShowClassTimeDialog(false);
    },
    change() {
      this.$emit("change");
    }
  },
  computed: {
    ...mapState("showClass", ["classSchedule"]),
    ...mapState("showClass", ["showClassTimeDialog"])
  }
};
</script>
